export default __webpack_public_path__ + "static/media/camera-icon.1deed8c1.svg";